import {
  doc,
  onSnapshot,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

export function createVentasComisionRepository({ getFirebase }) {
  async function registrarComisionRegularizada(uid) {
    const { db } = getFirebase();
    await updateDoc(doc(db, 'usuarios', uid), {
      comision_deuda_ars: 0,
      comision_ventas_impagas_count: 0,
      actualizadoEn: serverTimestamp(),
    });
  }

  async function crearPagoComisionMercadoPago() {
    const { fns } = getFirebase();
    if (!fns) throw new Error('Functions no está inicializado.');
    const call = httpsCallable(fns, 'createComisionPaymentPreference');
    const res = await call({});
    return res?.data || null;
  }

  /** Cuando el webhook de MP baja la deuda, el snapshot dispara y podés refrescar la vista. */
  function escucharBajadaDeudaComision({ uid, deudaReferenciaArs, onBajada }) {
    const { db } = getFirebase();
    if (!db || typeof onBajada !== 'function') return () => {};
    const refv = Number(deudaReferenciaArs) || 0;
    if (refv <= 0) return () => {};
    const uref = doc(db, 'usuarios', uid);
    let listo = false;
    const unsub = onSnapshot(uref, (snap) => {
      if (listo || !snap.exists()) return;
      const deuda = Number(snap.data()?.comision_deuda_ars) || 0;
      if (deuda < refv - 0.005) {
        listo = true;
        unsub();
        onBajada({ deudaNuevaArs: deuda });
      }
    });
    return unsub;
  }

  return {
    registrarComisionRegularizada,
    crearPagoComisionMercadoPago,
    escucharBajadaDeudaComision,
  };
}
